module.exports = __webpack_public_path__ + "img/excited.add5acb2.png";